module.exports = __webpack_public_path__ + "img/tj.ac3f66d0.svg";